import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";
import { getInitials } from "../utils/formatters";
import NotificationBell from "./NotificationBell";
import MuiPopper from "./ui/MuiPopper";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import Breadcrumb from "./Breadcrumb";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";

import {
  HelpCircle,
  UserCircle,
  LockKeyhole,
  Sparkles,
  Contrast,
  FileText,
} from "lucide-react";
import ContentCard from "./ui/ContentCard";
import MyAccount from "./MyAccount";
const TopNavigation = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () => {
    logout();
  };

  const [showThemeList, setShowThemeList] = useState(false);
  const { updateTheme } = useTheme();
  const themes = [{ theme: "Light" }, { theme: "Dark" }, { theme: "System" }];

  function RenderThemeList({ handleClose }) {
    const themeList = themes.map((thememode) => {
      return (
        <button
          onClick={async () => {
            await updateTheme(thememode.theme.toUpperCase());
            setShowThemeList(false);
            handleClose();
          }}
          className="flex flex-row ml-8 items-center"
        >
          <ContentCard
            variant={thememode.theme === "Light" ? "light" : "dark"}
            className={"basis-1/3 mr-4"}
          ></ContentCard>
          <p className={"text-center"}>{thememode.theme}</p>
        </button>
      );
    });
    return themeList;
  }

  return (
    <header className="shrink-0 border-b border-border-primary bg-bg-primary shadow-none">
      <div
        className="mx-auto px-4 sm:px-6 lg:px-8"
        style={{ background: "var(--color-bg-selectedgray)" }}
      >
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Breadcrumb />
          </div>
          <div className="flex items-center space-x-4">
            <NotificationBell />
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopNavigation;
